import { render, staticRenderFns } from "./declareSearch.vue?vue&type=template&id=07dbf27a&scoped=true"
import script from "./declareSearch.vue?vue&type=script&lang=js"
export * from "./declareSearch.vue?vue&type=script&lang=js"
import style0 from "./declareSearch.vue?vue&type=style&index=0&id=07dbf27a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbf27a",
  null
  
)

export default component.exports